import React from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import { H3, P } from "./typography";
import { getFontFamily } from "../utils";
import FadeIn from "./atoms/FadeIn";

const Section = styled.div`
  display: grid;
  text-align: center;
  background-color: ${({ theme, color }) => theme.colors[color]};
  color: ${({ theme, fontColor }) => theme.colors[fontColor]};
  align-conent: center;
  margin: auto;
  padding: ${({ padding }) =>
    padding ? padding : "8rem 6.25rem 12rem 6.25rem"};
`;

const Quote = H3.extend`
  display: inline-block;
  line-height: 1.5;
  padding: 1rem;
  text-align: center;
  ${getFontFamily};
  font-size: 2.5rem;
  font-weight: 400;
  strong {
    font-weight: 500;
  }

  ${props => props.theme.media.tablet`
    font-size: 1.65rem;
  `};
`;

const Author = P.extend`
  line-height: 1.5;
  font-size: 1rem;
  text-align: center;
`;

export default ({
  color = "transparent",
  quote = "",
  author = "",
  fontColor = "dark",
  padding = null,
  zIndex = null,
  style = {},
  ...props
}) => {
  return (
    <Section
      color={color}
      fontColor={fontColor}
      padding={padding}
      style={{ ...style, zIndex }}
    >
      <FadeIn>
        <Quote {...props}>
          <ReactMarkdown source={quote} />
        </Quote>
        <Author align="center">
          {author}
        </Author>
      </FadeIn>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/components/HeroQuote.js